import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {ChildService} from "../../../../components/child/child.service";
import {CounselingService} from "../../counseling.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DatePipe, TitleCasePipe} from "@angular/common";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {FullChild} from "../../../../interfaces/FullChild";
import {MatSelectChange} from "@angular/material/select";
import {MatTableDataSource} from "@angular/material/table";
import {
  ViewIndividualAssessmentComponent
} from "../../components/view-individual-assessment/view-individual-assessment.component";
import {
  EditIndividualCounselingComponent
} from "../../components/edit-individual-counseling/edit-individual-counseling.component";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {MatDialog} from "@angular/material/dialog";
import {AngularFirestoreCollection} from "@angular/fire/compat/firestore";
import {AssessmentModel} from "../../../../interfaces/AssessmentModel";
import {EmployeeService} from "../../../../services/employee.service";
import {Employee} from "../../../../interfaces/Employee";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";

@Component({
  selector: 'app-counselling-individuals-report',
  templateUrl: './counselling-individuals-report.component.html',
  styleUrls: ['./counselling-individuals-report.component.scss']
})
export class CounsellingIndividualsReportComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  centres$: Observable<Centre[]>

  children$?: Observable<FullChild[]>
  startTime: any
  endTime: any
  centreSelect = new FormControl('', [Validators.required]);
  childSelect = new FormControl('', [Validators.required]);
  types=["Admission Rapport building counselling","Regular Counselling","Discharge Counselling","Follow-up Counselling", "Others"]
  mAllData:any[]=[]
  mFilteredData:any[]=[]

  displayedColumns: string[] = ['createdAt', 'childName', 'centreName','type', 'date', 'Action'];
  data:any

  selectedCentre?:string|null=''
  dataSource!: MatTableDataSource<AssessmentModel>;
  startDate?: Date | null
  endDate?: Date | null
  selectedCentreCode?: string | null
  private baseRef!: AngularFirestoreCollection<FullChild>;
  childData: FullChild[] = []
  sessionType:string=''
  counselorName=''
  employee: Observable<Employee[]>
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(private centreService: CentreService,
              private childService: ChildService,
              private readonly matDialog: MatDialog,
              private  counselingService: CounselingService,
              private readonly datePipe: DatePipe,
              private _snackBar: MatSnackBar,
              private employeeService: EmployeeService,
              private titlecasePipe: TitleCasePipe,) {
    this.centres$ = this.centreService.getAllCentres()
this.dataSource = new MatTableDataSource<AssessmentModel>()
    this.employee = this.employeeService.getCounsellersFromUsers()

  }

  ngOnInit(): void {
    // this.counselingService.fetchIndividualSessions().subscribe(tables => {
    //     console.log(tables)
    //     this.dataSource = tables;
    //
    //   })
    this.counselingService.fetchIndividualSessions().pipe(takeUntil(this._destroyed$)).subscribe(res=>{
      this.mAllData = res
      this.dataSource.data = this.mAllData
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }

  fetchChildren($event: MatSelectChange) {
    let centre = $event.value as Centre
    // alert(centre)
    this.children$ = this.childService.getAllotedChildListByCenter(centre.centreCode)

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

  getDate(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy');
    return datePipeString
  }

  viewDialog(element: any) {
    this.matDialog.open(ViewIndividualAssessmentComponent, {
      data: element,
      width: '800%',
      height: '90%'
    })
  }



  dynamicQuery() {
    // FROM TO CENTRE GENDER LOCATION HOSPITAL DIAGONSIS
    let myQuery: firebase.firestore.Query<FullChild> = this.baseRef.ref;


    if (this.isCentre()) {
      console.log('into centrecode')

      myQuery = myQuery.where('centreCode', '==', this.selectedCentreCode);
    }




    // qs.docs.map(x=>x.data() as FullChild)}
    // )


  }


  clearAll() {
this.startDate = null
    this.endDate =null
    this.counselorName =''
    this.selectedCentre = ''
    this.sessionType =''
    this.dataSource.data =this.mAllData
  }

  setSelectedCentreCode($event: MatSelectChange) {
    this.selectedCentreCode = $event.value

    console.log(this.selectedCentreCode)
    //this.getData(this.selectedCentreCode)
  }

  isCentre() {
    return this.selectedCentreCode != null
  }
getEmployee(){



}

  Search() {
    this.mFilteredData = this.mAllData
    console.log(this.mFilteredData)
  // if centre selected
// 100
    if(this.selectedCentre!=null && this.selectedCentre!=''){
      console.log(this.selectedCentre)
      console.log('into selectedCentre')
      this.mFilteredData = this.mFilteredData.filter((x)=> x.centreCode == this.selectedCentre)
    }
   if(this.startDate!=null){
     console.log('into startDate')

     this.mFilteredData =  this.mFilteredData.filter((x)=> (x.date  as unknown as Timestamp).toDate()>=this.startDate!)
// 50
   }
    if(this.endDate!=null){
      console.log('into dateofassessment')

     // 50
      this.mFilteredData =  this.mFilteredData.filter((x)=>(x.date as unknown as Timestamp).toDate()<=this.endDate!)

    }

    if(this.sessionType!=null && this.sessionType!=''){
      this.mFilteredData = this.mFilteredData.filter((x)=> x.type ==this.sessionType)
    }

    if(this.counselorName!=null && this.counselorName!=''){
      this.mFilteredData = this.mFilteredData.filter((x)=> x.personConductingTest ==this.counselorName)
      console.log(this.mFilteredData)
    }



    this.dataSource.data=this.mFilteredData
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
// Alldata =filter data
// then when clicked on search button
// filterData= Alldata.filter((r)=>condition )
// 1  Fetch All Individual Sessions then store it into mAllSessions
// 2
// Filter Logic
// let admission = child.filter((c) => c.centreCode == centreCode && c.dateOfAdmission.toDate() > startDate && c.dateOfAdmission.toDate() < endDate)
